module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showDisplay) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.$route.name == 'segment')),
      expression: "!($route.name == 'segment')"
    }]
  }), _vm._v(" "), _c('preview'), _vm._v(" "), (_vm.$route.name.includes('segment') || _vm.$route.name.includes('Segment')) ? _c('editor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'segment'),
      expression: "$route.name == 'segment'"
    }]
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 830
// module chunks = 1 3